// These must be the first lines in src/index.js
// @see: https://create-react-app.dev/docs/supported-browsers-features/
// @see: https://github.com/facebook/create-react-app/blob/master/packages/react-app-polyfill/README.md
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import ReactDOM from 'react-dom';

import axios from 'axios';
import { axiosInterceptor } from 'pa-eipermi-client';

// NOTE: importing from 'pa-react' increases app build by 745KB
import EventBusService from 'pa-react/dist/core/eventBus/EventBusService';

import './index.css';
import SupplierSearchApp from './components/SupplierSearchApp';

//
// --- Setup Event Bus Service ---

// Dont override already existing eventBusService that could be created by a parent app I.E. grid.
if (!window.top.eventBusService) {
  window.top.eventBusService = new EventBusService();
}

//
// --- Render App ---

// NOTE: Can't currently use strict mode because of outdated components in pa-react
// ReactDOM.render(
//   <React.StrictMode>
//     <SupplierSearchApp />
//   </React.StrictMode>,
//   document.getElementById("root")
// );

axiosInterceptor(axios, '/auth/getAuthenticationJWT');

ReactDOM.render(<SupplierSearchApp />, document.getElementById('root'));
